import clsx from 'clsx'
import PropTypes from 'prop-types'
import React, { Fragment, useMemo } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import SizeTable from 'components/common/size-table'
import { PDP_INTERACT_ELEM_EVENT_NAME } from 'components/pdp/const'
import {
  MEASUREMENT_DATA,
  MEASUREMENT_TYPE,
} from 'components/pdp/interactions/measurements/const'
import ModelInfo from 'components/pdp/interactions/measurements/model-info'
import {
  getTableColumns,
  getTableRows,
} from 'components/pdp/interactions/measurements/utils'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import { segmentTrackPDPInteract } from 'lib/utils/product'

const BodySizeTable = ({
  internationalization: { country },
  openModal,
  product,
  t,
  unit,
  sizeHeader,
  hideModelInfo,
}) => {
  const { attributes, is_new_size_method: isNewSize = false, model } = product

  const rows = useMemo(
    () => getTableRows(attributes, t, MEASUREMENT_TYPE.new_body, unit),
    [attributes, t, unit],
  )
  const bodyTableColumns = useMemo(
    () => getTableColumns(rows, sizeHeader),
    [rows, sizeHeader],
  )

  return (
    <Fragment>
      <div className="pdp-measurements__table body">
        <SizeTable
          columns={bodyTableColumns}
          rows={rows}
          isNewSize={isNewSize}
          isPhone
        />
      </div>
      {model && !hideModelInfo && (
        <ModelInfo customClass="for-dual-table" model={model} />
      )}
      <div className="pdp-measurements__inter-sizing__wrapper">
        <button
          className={clsx('pdp-measurements__inter-sizing', Typo.overline)}
          onClick={() => {
            segmentTrackPDPInteract(
              product,
              country,
              PDP_INTERACT_ELEM_EVENT_NAME.interSizing,
            )
            openModal(true)
          }}
        >
          {hasLocizeTranslation(
            t,
            MEASUREMENT_DATA.measurementTitle.titleKey,
            MEASUREMENT_DATA.measurementTitle.default,
          )}
        </button>
      </div>
    </Fragment>
  )
}

BodySizeTable.defaultProps = { sizeHeader: null, hideModelInfo: false }

BodySizeTable.propTypes = {
  hideModelInfo: PropTypes.bool,
  sizeHeader: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    titleKey: PropTypes.string,
  }),
  internationalization: PropTypes.shape({
    country: PropTypes.string,
  }).isRequired,
  openModal: PropTypes.func.isRequired,
  product: PropTypes.shape({
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        measurement_type_body: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
            value_in: PropTypes.string,
          }),
        ),
      }),
    ),
    is_new_size_method: PropTypes.bool,
    model: PropTypes.shape({}),
  }).isRequired,
  t: PropTypes.func.isRequired,
  unit: PropTypes.string.isRequired,
}

export default compose(
  connect((state) => ({
    internationalization: state.internationalization,
  })),
  withI18next(),
)(BodySizeTable)
